export const LOAD_RUNS_SUCCESS = 'LOAD_RUNS_SUCCESS';
export const LOAD_CHECKLIST_SUCCESS = 'LOAD_CHECKLIST_SUCCESS';
export const RUN_LOCATION_CHECKIN = 'RUN_LOCATION_CHECKIN';
export const RUN_LOCATION_CHECKIN_SUCCESS = 'RUN_LOCATION_CHECKIN_SUCCESS';
export const RUN_LOCATION_CHECKIN_ERROR = 'RUN_LOCATION_CHECKIN_ERROR';
export const RUN_LOCATION_TANK_PICKUP = 'RUN_LOCATION_TANK_PICKUP';
export const RUN_LOCATION_TANK_PICKUP_SUCCESS = 'RUN_LOCATION_TANK_PICKUP_SUCCESS';
export const RUN_LOCATION_ADDNOTE_SUCCESS = 'RUN_LOCATION_ADDNOTE_SUCCESS';

export const LOAD_RUN_SUCCESS = 'LOAD_RUN_SUCCESS';
export const LOAD_DRIVER_RUNS_SUCCESS = 'LOAD_DRIVER_RUNS_SUCCESS';
export const DEVICE_LOCATION_SUCCESS = 'DEVICE_LOCATION_SUCCESS';

export const LOAD_DRIVER_LOCATIONS_SUCCESS = 'LOAD_DRIVER_LOCATIONS_SUCCESS';

export const LOAD_DRIVERS_SUCCESS = 'LOAD_DRIVERS_SUCCESS';
export const LOAD_TRUCKS_SUCCESS = 'LOAD_TRUCKS_SUCCESS';
export const SAVE_TRUCK_SUCCESS = 'SAVE_TRUCK_SUCCESS';
export const DELETE_TRUCK_SUCCESS = 'DELETE_TRUCK_SUCCESS';

export const NEW_RUN_LOCATION_ADD = 'NEW_RUN_LOCATION_ADD';
export const NEW_RUN_LOCATION_REMOVE = 'NEW_RUN_LOCATION_REMOVE';
export const NEW_RUN_LOCATION_SETURGENT = "NEW_RUN_LOCATION_SETURGENT";
export const NEW_RUN_EDIT = "NEW_RUN_EDIT";
export const NEW_RUN_CREATED = "NEW_RUN_CREATED";
export const NEW_RUN_SAVING = "NEW_RUN_SAVING";

export const LOAD_REGIONS_SUCCESS = 'LOAD_REGIONS_SUCCESS';
export const LOAD_SUBURBS_UNMAPPED_SUCCESS = 'LOAD_SUBURBS_UNMAPPED_SUCCESS';


export const SAVE_SUBURBS_TOREGION_SUCCESS = 'SAVE_SUBURBS_TOREGION_SUCCESS';
export const REMOVE_SUBURB_FROMREGION_SUCCESS = 'REMOVE_SUBURB_FROMREGION_SUCCESS';
export const CREATE_REGION_SUCCESS = 'CREATE_REGION_SUCCESS';
export const UPDATE_REGION_SUCCESS = 'UPDATE_REGION_SUCCESS';
export const DELETE_REGION_SUCCESS = 'DELETE_REGION_SUCCESS';

export const LOAD_SMS_PICKUP_USER_SUCCESS = 'LOAD_SMS_PICKUP_USER_SUCCESS';

export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const SAVE_USER_SUCCESS = 'SAVE_USER_SUCCESS';
export const SAVE_USER_ERROR = 'SAVE_USER_ERROR';
export const LOAD_ROLES_SUCCESS = 'LOAD_ROLES_SUCCESS';

export const LOAD_BDMS_SUCCESS = 'LOAD_BDMS_SUCCESS';
export const SAVE_BDM_CLIENT_SUCCESS = 'SAVE_BDM_CLIENT_SUCCESS';
export const DELETE_BDM_CLIENT_SUCCESS = 'DELETE_BDM_CLIENT_SUCCESS';

export const LOAD_CLIENTS_SUCCESS = "LOAD_CLIENTS_SUCCESS";
export const SAVE_CLIENT_SUCCESS = "SAVE_CLIENT_SUCCESS";
export const SAVE_CLIENT_SAVING = "SAVE_CLIENT_SAVING";
export const SAVE_CLIENT_ERROR = 'SAVE_CLIENT_ERROR';
export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS";

export const LOAD_LOCATIONS_SUCCESS = "LOAD_LOCATIONS_SUCCESS";
export const SAVE_LOCATION_SUCCESS = "SAVE_LOCATION_SUCCESS";
export const SAVE_LOCATION_SAVING = "SAVE_LOCATION_SAVING";
export const SAVE_LOCATION_ERROR = 'SAVE_LOCATION_ERROR';
export const DELETE_LOCATION_SUCCESS = "DELETE_LOCATION_SUCCESS";

// Rebates RCTI
export const LIST_REBATES_RCTI_SUCCESS = "LIST_REBATES_RCTI_SUCCESS";
export const CLEAR_REBATES_RCTI_SUCCESS = "CLEAR_REBATES_RCTI_SUCCESS";
export const LIST_RCTI_INVOICES_SUCCESS = "LIST_RCTI_INVOICES_SUCCESS";
export const CLEAR_RCTI_INVOICES_SUCCESS = "CLEAR_RCTI_INVOICES_SUCCESS";
export const GET_REBATES_RCTI_DETAIL_SUCCESS = "GET_REBATES_RCTI_DETAIL_SUCCESS";
export const CLEAR_REBATES_RCTI_DETAIL_SUCCESS = "CLEAR_REBATES_RCTI_DETAIL_SUCCESS";
export const UPDATE_REBATES_RCTI_LIST_FILTERS_SUCCESS = "UPDATE_REBATES_RCTI_LIST_FILTERS_SUCCESS";

// MYOB Integration
export const LIST_COMPANY_FILES_SUCCESS = "LIST_COMPANY_FILES_SUCCESS";
export const CLEAR_COMPANY_FILES_SUCCESS = "CLEAR_COMPANY_FILES_SUCCESS";

export const LOAD_RUNS_FILTERCHANGED = 'LOAD_RUNS_FILTERCHANGED';

// Truck Data (unified weight + receipt)
export const LOADING_TRUCK_DATA = 'LOADING_TRUCK_DATA';
export const LOAD_TRUCK_DATA_SUCCESS = 'LOAD_TRUCK_DATA_SUCCESS';
export const LOAD_TRUCK_DATA_ERROR = 'LOAD_TRUCK_DATA_ERROR';

// Truck Data pushed live over SignalR (replaces polling the truck-proxy over truck wifi)
export const TRUCK_HUB_CONNECTION = 'TRUCK_HUB_CONNECTION';
export const TRUCK_HUB_WEIGHT = 'TRUCK_HUB_WEIGHT';
export const TRUCK_HUB_RECEIPT = 'TRUCK_HUB_RECEIPT';
export const TRUCK_HUB_CONTEXT = 'TRUCK_HUB_CONTEXT';
export const TRUCK_HUB_LOCATION = 'TRUCK_HUB_LOCATION';

// Run receipts (truck receipts scoped to a run: unassigned candidates + this-run assigned)
export const RUN_RECEIPTS_LOADING = 'RUN_RECEIPTS_LOADING';
export const RUN_RECEIPTS_LOADED = 'RUN_RECEIPTS_LOADED';

export const LOAD_API_CONFIG_SUCCESS = 'LOAD_API_CONFIG_SUCCESS';

// Home
export const LIST_COLLECTION_HISTORY = "LIST_COLLECTION_HISTORY";
export const CLEAR_COLLECTION_HISTORY = "CLEAR_COLLECTION_HISTORY";
export const LIST_CLIENT_LOCATIONS = "LIST_CLIENT_LOCATIONS";
export const CLEAR_CLIENT_LOCATIONS = "CLEAR_CLIENT_LOCATIONS";
export const LIST_CLIENT_LOCATIONS_DELIVERY = "LIST_CLIENT_LOCATIONS_DELIVERY";
export const CLEAR_CLIENT_LOCATIONS_DELIVERY = "CLEAR_CLIENT_LOCATIONS_DELIVERY";

// Admin Pending Requests
export const LIST_PENDING_REQUESTS = "LIST_PENDING_REQUESTS";
export const CLEAR_PENDING_REQUESTS = "CLEAR_PENDING_REQUESTS";
export const GET_PENDING_REQUESTS_COUNT = "GET_PENDING_REQUESTS_COUNT";
export const CLEAR_PENDING_REQUESTS_COUNT = "CLEAR_PENDING_REQUESTS_COUNT";

// Lookups
export const LOAD_COLLECTION_TYPES_SUCCESS = 'LOAD_COLLECTION_TYPES_SUCCESS';
